import { InstrumentParams } from '../../types/common';

export interface TabProps {
  isActive: boolean;
  onClick: () => void;
}

export interface ContentProps {
  parameters: InstrumentParams;
}
export interface CardInstrumentComponents {
  Tab: React.FC<TabProps>;
  Content: React.FC<ContentProps>;
}
